import {getWrappedComponent} from '../../../appConfig';
import {sliderGlobalPropsStrategy} from '../../../sliderGallery/sliderGlobalStrategy';
import styleParams from '../stylesParams';
import {SliderGallery} from '../../../sliderGallery/components/SliderGallery/SliderGallery';

export default getWrappedComponent({
  Component: SliderGallery,
  stylesParams: styleParams,
  globalPropsStrategy: sliderGlobalPropsStrategy,
  sliderGallery: true,
});
